import type { Level } from "@shared/access/levels";
import type { ResourcePath } from "@shared/access/resources";
import type { PlaceRef } from "../auth/access";
import type { SignageScopeRef } from "../http/foyer";

export interface SignageGate {
  readonly resource: ResourcePath;
  readonly level: Level;
  /** Absent: the page's place. */
  readonly place?: PlaceRef;
}

/** The gate for a write in `scope`, as its route declares it; without a scope, edit at the page's place. */
export function signageWriteGate(
  scope?: SignageScopeRef,
  resource: ResourcePath = "signage"
): SignageGate {
  if (!scope) return { resource, level: "edit" };
  switch (scope.kind) {
    case "global":
      return { resource, level: "administrate", place: "global" };
    case "premise":
      return { resource, level: "edit", place: { premiseId: scope.premiseId } };
    case "company":
      return { resource, level: "edit", place: { companyId: scope.companyId } };
  }
}
